import React, { useState, useCallback, useContext } from "react";
import { Button, Modal, Container, Row, Col, Alert } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import AuthContext from "../../context/AuthContext";
import { createClienteService } from "../../utils/ClienteService";

function CreateClienteModal({clientes, setClientes}) {

  const { authTokens } = useContext(AuthContext);

  // States del Modal
  const [show, setShow] = useState(false);
  const [error, setError] = useState(false);
  // clean state
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // States de los campos del form.
  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [domicilio, setDomicilio] = useState("");
  const [telefono, setTelefono] = useState("");
  const [mail, setMail] = useState("");
  const [largoPelo, setLargoPelo] = useState("C");
  const [detalle, setDetalle] = useState("");
  const [cumpleaños, setCumpleaños] = useState("");

  // Funcion encargada de poner mayusculas
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const createCliente = useCallback(async (cliente) => {
    createClienteService(cliente, authTokens).then((response) => {
      clientes.push(response);
      const aux = clientes.map((cli) => cli);
      setClientes(aux);
    });
  });

  // Funcion encargada de tomar los datos del form y actualizar el cliente en la DB.
  async function handleCreate() {
    // Si el campo cumpleaños esta vacio ponemos por defecto una fecha para no romper el backend.
    const defaultCumple = cumpleaños !== "" ? cumpleaños : "1950-01-01";

    const clienteCreado = {
      apellido: capitalizeFirstLetter(apellido),
      nombre: capitalizeFirstLetter(nombre),
      domicilio: capitalizeFirstLetter(domicilio),
      telefono: telefono,
      mail: mail,
      info: capitalizeFirstLetter(detalle),
      cumpleaños: defaultCumple,
      largo_pelo: largoPelo,
    };
    // Verificamos que todos los campos fueron completados, sino ponemos error en 'true' y disparamos el alert.
    if (
      clienteCreado.apellido !== "" &&
      clienteCreado.nombre !== "" &&
      clienteCreado.telefono !== "" &&
      clienteCreado.largo_pelo !== ""
    ) {
      createCliente(clienteCreado);
      handleClean();
      handleClose();
    } else {
      setError(true);
    }
  }

  // Funcion encargada de limpiar los valores en cada input del formulario cuando se cancela el create.
  const handleClean = () => {
    setNombre("");
    setApellido("");
    setDomicilio("");
    setTelefono("");
    setMail("");
    setLargoPelo("C");
    setDetalle("");
    setCumpleaños("");
    setError(false);

    handleClose();
  };

  return (
    <>
      <Button variant="success" size="sm" onClick={handleShow}>
        Nuevo Cliente
      </Button>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <Modal.Header closeButton onClick={handleClean}>
          <Modal.Title>Crear nuevo cliente</Modal.Title>
        </Modal.Header>
        <Modal.Body className="show-grid">
          <Container>
            {error && (

              <Alert variant="danger">
                ¡Debe completar los campos: nombre, apellido, teléfono y largo
                de pelo!
              </Alert>

            )}
            <Row>
              <Col xs={12} md={6}>
                <Form.Group
                  onChange={(e) => {
                    setNombre(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Nombre:</Form.Label>
                  <Form.Control
                    type="text"
                    required={true}
                    defaultValue={nombre}
                    placeholder="Nombre"
                  />
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                <Form.Group
                  onChange={(e) => {
                    setApellido(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Apellido:</Form.Label>
                  <Form.Control
                    type="text"
                    defaultValue={apellido}
                    placeholder="Apellido"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col xs={12} md={4}>
                <Form.Group
                  onChange={(e) => {
                    setDomicilio(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Domicilio:</Form.Label>
                  <Form.Control
                    type="text"
                    defaultValue={domicilio}
                    placeholder="Domicilio"
                  />
                </Form.Group>
              </Col>

              <Col xs={12} md={5}>
                <Form.Group
                  onChange={(e) => {
                    setTelefono(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Teléfono</Form.Label>
                  <Form.Control
                    type="text"
                    defaultValue={telefono}
                    placeholder="Teléfono"
                  />
                </Form.Group>
              </Col>

              <Col xs={6} md={3}>
                <Form.Group
                  onChange={(e) => {
                    setLargoPelo(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Largo del pelo:</Form.Label>
                  <Form.Select>
                    <option value={"C"}>Corto</option>
                    <option value={"M"}>Medio</option>
                    <option value={"L"}>Largo</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={8}>
                <Form.Group
                  onChange={(e) => {
                    setMail(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Mail:</Form.Label>
                  <Form.Control
                    type="email"
                    defaultValue={mail}
                    placeholder="Mail"
                  />
                </Form.Group>
              </Col>

              <Col xs={10} md={4}>
                <Form.Group
                  onChange={(e) => {
                    setCumpleaños(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Cumpleaños:</Form.Label>
                  <Form.Control type="date" defaultValue={cumpleaños} />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={12}>
                <Form.Group
                  onChange={(e) => {
                    setDetalle(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Detalle:</Form.Label>
                  <Form.Control
                    as="textarea"
                    defaultValue={detalle}
                    placeholder="Información adicional"
                  />
                </Form.Group>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-danger" size="sm" onClick={handleClean}>
            Cancelar
          </Button>
          <Button
            onClick={() => handleCreate()}
            variant="outline-success"
            size="sm"
          >
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default CreateClienteModal;
